import React, { useState } from 'react';
import {
  Box,
  Icon,
  Popover,
  PopoverContent,
  PopoverLauncher,
  Button,
  Typography,
} from '@vp/swan';
import PropTypes from 'prop-types';

function Expando({ label, children }) {
  const [expanded, setExpanded] = useState(false);

  return expanded ? (
    <>
      <Button skin="unstyled" onClick={() => setExpanded(false)}>
        {label} -
      </Button>
      <br />
      {children}
    </>
  ) : (
    <Button skin="unstyled" onClick={() => setExpanded(true)}>
      {label} +
    </Button>
  );
}

Expando.propTypes = {
  label: PropTypes.string.isRequired,
  children: PropTypes.element.isRequired,
};

function Content({ aggregatedTaxAwarePrice }) {
  const {
    taxAwareDiscountedCents,
    taxAwareListCents,
    includedTaxes,
    excludedTaxes,
  } = aggregatedTaxAwarePrice;
  return (
    <>
      <Typography fontSize={1}>
        Discounted Cents: {taxAwareDiscountedCents}
      </Typography>
      <Typography fontSize={1}>List Cents: {taxAwareListCents}</Typography>
      {includedTaxes && (
        <Typography fontSize={1}>
          {includedTaxes.length > 0 ? (
            <Expando label="Included Taxes: [...]">
              <pre style={{ overflowX: 'scroll' }}>
                {JSON.stringify(includedTaxes, null, 2)}
              </pre>
            </Expando>
          ) : (
            <>Included Taxes: []</>
          )}
        </Typography>
      )}
      {excludedTaxes && (
        <Typography fontSize={1}>
          {excludedTaxes.length > 0 ? (
            <Expando label="Excluded Taxes: [...]">
              <pre style={{ overflowX: 'scroll' }}>
                {JSON.stringify(excludedTaxes, null, 2)}
              </pre>
            </Expando>
          ) : (
            <>Excluded Taxes: []</>
          )}
        </Typography>
      )}
    </>
  );
}

Content.propTypes = {
  aggregatedTaxAwarePrice: PropTypes.shape({
    taxAwareDiscountedCents: PropTypes.number.isRequired,
    taxAwareListCents: PropTypes.number.isRequired,
    includedTaxes: PropTypes.array.isRequired,
    excludedTaxes: PropTypes.array.isRequired,
  }).isRequired,
};

export function DebugTaxInfo({
  header,
  aggregatedTaxAwarePrice,
  displaySubtotals,
}) {
  const { subtotals, ...theRest } = aggregatedTaxAwarePrice;
  const subtotalKeys = (subtotals && [...subtotals.keys()]) || [];
  return (
    <Popover position="bottom">
      <PopoverLauncher
        onClick={e => {
          e.stopPropagation();
        }}
      >
        <Typography fontSize={1} textColor="dark-grey">
          <Icon color="dark-grey" iconType="info" /> Tax Debug Info
        </Typography>
      </PopoverLauncher>
      <PopoverContent dialog>
        <Typography fontSize={1} fontWeight="bold" mb={2}>
          Raw Tax Debug Info for {header}
        </Typography>
        <div style={{ overflowY: 'scroll', maxHeight: '400px' }}>
          <Content aggregatedTaxAwarePrice={theRest} />
          {displaySubtotals && subtotalKeys.length > 0 && (
            <>
              <Typography fontSize={1}>Subtotals:</Typography>
              {[...subtotals.keys()].map(key => (
                <Box ml={2} key={key}>
                  <Typography fontSize={1}>
                    <Expando label={`${key} `}>
                      <Typography ml={2}>
                        <Content aggregatedTaxAwarePrice={subtotals.get(key)} />
                      </Typography>
                    </Expando>
                  </Typography>
                </Box>
              ))}
            </>
          )}
        </div>
      </PopoverContent>
    </Popover>
  );
}

DebugTaxInfo.propTypes = {
  header: PropTypes.string.isRequired,
  aggregatedTaxAwarePrice: PropTypes.shape({
    taxAwareDiscountedCents: PropTypes.number.isRequired,
    taxAwareListCents: PropTypes.number.isRequired,
    includedTaxes: PropTypes.array.isRequired,
    excludedTaxes: PropTypes.array.isRequired,
    subtotals: PropTypes.any,
  }).isRequired,
  displaySubtotals: PropTypes.bool,
};
